import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@elparking/components'
import Routes from 'commons/js/routes/routes'
import PriceDetails from 'rental-car-contract/js/components/RentalCarContract/PriceDetails'
import OfferApplied from 'rental-car-contract/js/components/RentalCarContract/OfferApplied'
import Cashback from 'rental-car-contract/js/components/RentalCarContract/Cashback'
const ExtraInfoBlock = ({
    booking,
    cashbackInfoURL,
}) => {
    const { cashBack } = booking
    return <Flex flexDirection='column'>
        <Box mt='1em' padding='1em' backgroundColor='gray10'>
            <PriceDetails booking={booking} />
        </Box>

        <OfferApplied isMutuaUser />
        {!booking.createdByOperator && <Cashback cashBack={cashBack} cashbackInfoURL={cashbackInfoURL}/>}
    </Flex>
}

ExtraInfoBlock.propTypes = {
    booking: PropTypes.object,
    cashbackInfoURL: PropTypes.string,
}

ExtraInfoBlock.defaultProps = {
    booking: {},
    isMutuaUser: false,
    cashbackInfoURL: Routes.cashbackInfoURL(),
}
export default ExtraInfoBlock
